module.exports = __webpack_public_path__ + "img/icon-question.933baafc.svg";